/**
 * 2023-10 rwg lightbox
 * depends on styles in css/rwg-lightbox.css
 * adds global event listener
 * returns three methods
 */

import createElementPlus from './util/createElementPlus.js'

export default function() {
  const contentDiv = createElementPlus('div', {styles: {margin: '12px'}})
  const btnClose = createElementPlus('a', {
    classes: ['rwg-lightbox-close'],
    eventListener: {evt: 'click', func: close},
    innerHTML: `&times;`
  })
  const btnRight = createElementPlus('a', {
    classes: ['rwg-lightbox-prev'],
    eventListener:  {evt: 'click', func: nav},
    innerHTML: '&#10094;',
  })
  const btnLeft =  createElementPlus('a', {
    classes: ['rwg-lightbox-next'],
    eventListener:  {evt: 'click', func: nav},
    innerHTML: '&#10095;',
  })

  const padding = 20
  let fileList  // array of img file names
  let fileIndex // current file in fileList
  let containerDiv

  // called when user clicks btnClose, also exported in case we need to close the lightbox programmatically
  function close() {
    const containerDiv = document.getElementById('rwg-lightbox')
    containerDiv.style.display = 'none'
    containerDiv.innerHTML = ''
  }

  // called when user clicks btnRight or btnLeft buttons
  function nav() {
    const images = document.querySelectorAll('img.rwg-lightbox')
    let current // currently displayed img
    let next    // img being navagated to (next or previous img in array)

    images.forEach((node, index) => {
      // if (node.checkVisibility()) {  // modern way but doesn't work in Safari 2023-11-28
      if (node.offsetParent) {      // Safari compatible way
        current = index
        node.style.display = 'none'
      }
    })

    if (this.classList.contains('next')) {  // right arrow, next image
      next = (current < images.length - 1) ? current + 1 : 0
    } else {         // left arrow, previous image
      next = (current > 0) ? current -1 : images.length - 1
    }
    images[next].style.display = 'block'
  }

  function appendImg() {
    const file = fileList[fileIndex]
    const styles = {
      display: fileIndex === 0 ? 'block' : 'none', // first img needs style.display="block"
      width: window.innerWidth - padding + 'px',
      height: innerHeight - padding + 'px',
    }
    contentDiv.append(createElementPlus('img', {
      src: file,
      classes: ["rwg-lightbox"],  // has to be an array
      title: file.substring(file.lastIndexOf('/') + 1),
      styles: styles,
      eventListener: {evt: 'load', func: loaded},
    }))
    fileIndex++
  }

  // a callback that  allows loading images sequentially rather than in parallel
  function loaded() {
    if (fileIndex > 0 && fileIndex < fileList.length) {
      appendImg()
    }
  }

  function open(event, files) {
    event.preventDefault()
    if (!files) return false // hopefully this is unnecessary
    containerDiv = document.getElementById('rwg-lightbox')
    containerDiv.innerHTML = ''
    containerDiv.style.display = 'block'

    contentDiv.innerHTML = ''
    containerDiv.append(contentDiv)

    fileList = files.split('|')
    fileIndex = 0

    appendImg()

    contentDiv.append(btnClose)
    if (fileList.length > 1) {
      contentDiv.append(btnRight)
      contentDiv.append(btnLeft)
    }

    return false
  }

  document.addEventListener("keydown", evt => {
    if (containerDiv &&                       // containerDiv not undefined
        containerDiv.offsetParent !== null && // containerDiv is visible (https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom)
        ['ArrowRight', 'ArrowLeft', 'Escape'].includes(evt.key)
    ) {
      switch (evt.key) {
        case 'ArrowRight':
          btnRight.click()
          break
        case 'ArrowLeft':
          btnLeft.click()
          break
        case 'Escape':
          btnClose.click()
          break
      }
    }
  })

  return {
    close: close,
    open: open,
    adjustSize: function() {
      const windowWidth = window.innerWidth - padding;
      const windowHeight = window.innerHeight - padding;
      document.querySelectorAll('img.rwg-lightbox').forEach(image => {
        image.style.width = windowWidth + 'px';
        image.style.height = windowHeight + 'px';
      })
    }
  }
}
